import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CreateUser, CreateUserResponse } from '../models/user';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  constructor(private http: HttpClient) { }

  createUser(user: CreateUser): Observable<CreateUserResponse> {
    return this.http.post<CreateUserResponse>('/admin/users/register', user);
  }

  searchUser(searchPayload: any){
    let params = new HttpParams();
    params = params.append("searchTerm", searchPayload['searchTerm']).append("pageable", searchPayload['pageable'])
    return this.http.get('/admin/users/search', { params });
  }

}
